import React from 'react'
import { ParticipantStatus, ChallengeStatus } from '../../utils/const'

const ChallengeEntry = ({ challengeId, type, status, created, lastUpdated, participantCount, runCount, cancel, interrupt }) => (
    <tr>
        <td>
            {challengeId}
        </td>
        <td>
            {type}
        </td>
        <td>
            {status}
        </td>
        <td>
            {dateFormat(created)}
        </td>
        <td>
            {dateFormat(lastUpdated)}
        </td>
        <td>
            {participantCount}
        </td>
        <td>
            {runCount}
        </td>
        <td>
            {cancelButton({ cancel, interrupt })}
        </td>
    </tr>
)



const cancelButton = ({ cancel, interrupt }) => {
    return <button type="button" name="button" onClick={cancel} disabled={interrupt}>
        {interrupt ? 'Cancelled...' : 'Cancel'}
    </button>;
}

function dateFormat(date) {
    if (typeof date === 'undefined')
        return null;

    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}



export default ChallengeEntry